import { render, staticRenderFns } from "./QuizResults.vue?vue&type=template&id=3744bf49&v-if=attempt%20%26%26%20attempt.attempt_id&"
import script from "./QuizResults.vue?vue&type=script&lang=js&"
export * from "./QuizResults.vue?vue&type=script&lang=js&"
import style0 from "./QuizResults.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports